export const CONSTANTS = {
  EMPTY_STRING: "",
  CONSIGNEE: "consignee",
  SHIPPER: "shipper",
  MAX_RECORDS: 2000,
  PAGING_BREAK_POINT: 100,
  NEXT_PAGE: "next",
  PREVIOUS_PAGE: "previous",
  COMMA_CHARACTER: "、",
  LIMIT_RECORD: "2000",
  DEFAULT_POSTAL_CD: "       ",
  TOKEN_ID_STATUS: "&tokenIdStatus=",
  HREF_PROCESS: "&processDiv=",
  FORMAT_DATE_YYYYMMDD: "YYYYMMDD",
  FORMAT_DATE_DISPLAY: "YYYY/MM/DD",
  FORMAT_DATE_MONENT: "YYYY-MM-DD",
  MAX_ERROR_EXPORT: 100,
  CONSIGNEE_MST_LIMIT_RECORD: 2000,
  SHIPPER_MST_LIMIT_RECORD: 100,
  ITEM_MST_LIMIT_RECORD: 1000,
  NEW_ISSUE_LOWER_LIMIT: 1,
  ISSUE_DATE_EXPIRATION: 7,
  ISSUE_SEARCH_LOWER_LIMIT: 365,
  REISSUE_SEARCH_LOWER_LIMIT: 90,
  VAT_REGISTER_DIV_NOT_REGIST: "99"
};
